import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Paper elevation={0} sx={{ p: 4, textAlign: 'center' }}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3" component="h1">
          404
        </Typography>
        <Typography color="text.secondary">
          The page you are looking for does not exist yet. Let’s build it!
        </Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard')}>
          Go to dashboard
        </Button>
      </Stack>
    </Paper>
  );
}

export default NotFoundPage;

